const vehicleTypes = ['sedan', 'minivan', 'van', 'bus', 'wheelchair', 'stretcher']
// const vehicleOptions = [
//   { vehicleType: 'sedan', maxRiders: 4 },
//   { vehicleType: 'minivan', maxRiders: 6 },
//   { vehicleType: 'van', maxRiders: 8 },
//   { vehicleType: 'bus', maxRiders: 17 },
// ]

export default vehicleTypes
